import { z } from "@/zod";

export const ASSIGMENT_STATUS = ["active", "inactive"] as const;

export const assignmentStatus = z.enum(ASSIGMENT_STATUS);

export const assignments = z.object({
  id: z.string().length(26).or(z.literal("")),
  contractor_id: z.string().length(26),
  contractor_name: z.string(),
  store_id: z.string().length(26),
  store_name: z.string(),
  start_date: z.string().date(),
  end_date: z.string().date().nullable(),
  status: assignmentStatus,
});
